import { render, staticRenderFns } from "./PersonalReport.vue?vue&type=template&id=7bc54ee0&scoped=true&"
import script from "./PersonalReport.vue?vue&type=script&lang=js&"
export * from "./PersonalReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport.vue?vue&type=style&index=0&id=7bc54ee0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc54ee0",
  null
  
)

export default component.exports